// extracted by mini-css-extract-plugin
export default {"colors":"ixdCFAWuQBmqYUvlHgts","wrapper":"hWEr_I9dsdCEoBzShs6p","dialog__item":"KUGn4r2XRyPXdqcq7c4s"};